module.exports = __webpack_public_path__ + "img/enemy.be73ce63.gif";